module.exports = __webpack_public_path__ + "img/dy.b845dbd1.png";